import { OwcIcon, OwcTypography } from "@one/react";
import { IconStatus } from "../../../constants";
import { formatUserDisplay } from "../../../utils/helpers/text";
import { useSelector } from "react-redux";
import { getBookingCategory, getBookingDisplayText } from "../helpFunctions";

const PopoverBookingTitle = ({ data }) => {
  const eventData = data?.eventData;
  const usersList = useSelector((state) => state.users.users) || [];

  const bookingBy = eventData?.createdBy;
  const creatorEmail = eventData?.createdByEmail;
  const user = usersList.find((candidate) => (
    (bookingBy && candidate?.userId === bookingBy)
    || (creatorEmail && candidate?.email === creatorEmail)
  ));
  const creatorLabel = user
    ? formatUserDisplay(user)
    : (creatorEmail || bookingBy || "Unknown User");
  const legacyCreatorLabel = user?.givenName && user?.familyName && user?.userId
    ? `${user.givenName} ${user.familyName} (${user.userId.split("_").pop()})`
    : creatorLabel;

  const displayText = getBookingDisplayText(eventData);
  const isInformationBooking = !!eventData?.isInformationBooking || getBookingCategory(eventData?.type) === "Information";
  const titleCreatorLabel = isInformationBooking ? creatorLabel : legacyCreatorLabel;

  const iconDetails = IconStatus.find((i) => i.text === displayText) ||
    IconStatus.find((i) => i.text === getBookingCategory(eventData?.type));

  return (
    <div>
      <div style={{ display: "flex" }}>
        <OwcIcon
          type="outlined"
          name={iconDetails?.icon}
          style={{
            color: iconDetails?.color,
            backgroundColor: `${iconDetails?.backgroundColor}`,
            width:'24px',
            height:'24px',
            fontSize:16,
            textAlign:"center",
            lineHeight:"24px",
            borderRadius:7,
          }}
        />
        <OwcTypography variant="button" style={{ paddingLeft: 10, color: iconDetails?.color }}>
          {`${displayText} by ${titleCreatorLabel}`}
        </OwcTypography>
      </div>
    </div>
  );
};

export default PopoverBookingTitle;
